import { isLocalRuntimeHost } from './runtimeHost';
import {
  getCurrentRuntimeHostname,
  getRuntimeEnvironment,
  inferRuntimeEnvironmentFromHostname,
} from './runtimeEnvironment';

// Only recognized hosts with a matching build may expose the internal tools.
export const getInternalAssistantEnvironment = ({
  hostname = getCurrentRuntimeHostname(),
  configuredEnvironment = process.env.REACT_APP_RUNTIME_ENV || '',
} = {}) => {
  if (isLocalRuntimeHost(hostname)) return 'local';
  const environment = inferRuntimeEnvironmentFromHostname(hostname);
  if (['beta', 'production'].includes(environment) &&
      getRuntimeEnvironment({ hostname, configuredEnvironment }) === environment) {
    return environment;
  }
  return null;
};
